import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone, CalendarCheck } from "lucide-react";
import Logo from "./Logo";
import { CLINIC } from "@/lib/site";

const LINKS = [
  { to: "/about", label: "About" },
  { to: "/treatments", label: "Treatments" },
  { to: "/conditions", label: "Conditions" },
  { to: "/pricing", label: "Pricing" },
  { to: "/gallery", label: "Gallery" },
  { to: "/articles", label: "Articles" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-alabaster/85 border-b border-teal-brand/10">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center justify-between h-[72px]">
        <Link to="/" data-testid="nav-logo-link" aria-label="Kamana Physiotherapy home">
          <Logo />
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `nav-link text-sm font-medium ${isActive ? "active text-teal-brand" : "text-inkmuted hover:text-teal-brand"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={CLINIC.phoneHref}
            data-testid="nav-call-button"
            className="flex items-center gap-2 text-sm font-semibold text-teal-brand border border-teal-brand/25 rounded-full px-4 py-2.5 hover:bg-teal-soft transition-colors duration-200"
          >
            <Phone size={15} /> {CLINIC.phone}
          </a>
          <Link
            to="/book-appointment"
            data-testid="nav-book-button"
            className="flex items-center gap-2 text-sm font-semibold text-alabaster bg-teal-brand hover:bg-teal-deep rounded-full px-5 py-2.5 transition-all duration-200 shadow-md hover:shadow-teal-brand/25 active:scale-95"
          >
            <CalendarCheck size={15} /> Book Consultation
          </Link>
        </div>

        <button
          className="lg:hidden p-2 text-teal-brand"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-alabaster border-t border-teal-brand/10 px-5 pb-6 pt-2">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              onClick={() => setOpen(false)}
              className="block py-3 text-base font-medium text-ink border-b border-teal-brand/5"
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/book-appointment"
            data-testid="nav-mobile-book-button"
            onClick={() => setOpen(false)}
            className="mt-4 flex items-center justify-center gap-2 text-sm font-semibold text-alabaster bg-teal-brand rounded-full px-5 py-3"
          >
            <CalendarCheck size={15} /> Book Consultation
          </Link>
          <a
            href={CLINIC.phoneHref}
            data-testid="nav-mobile-call-button"
            className="mt-2 flex items-center justify-center gap-2 text-sm font-semibold text-teal-brand border border-teal-brand/25 rounded-full px-5 py-3"
          >
            <Phone size={15} /> {CLINIC.phone}
          </a>
        </div>
      )}
    </header>
  );
}
